import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

const widths = { sm: '400px', md: '500px', lg: '640px' };

interface ModalCardProps {
  size?: 'sm' | 'md' | 'lg';
}

export const ModalCard = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'size'
})<ModalCardProps>`
  background: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.border.color.medium};
  border-radius: ${({ theme }) => theme.border.radius.md};
  box-shadow: ${({ theme }) => theme.boxShadow.superHeavy};
  width: 100%;
  max-width: ${({ size = 'md' }) => widths[size] || widths.md};
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(4, 5)};
  border-bottom: 1px solid ${({ theme }) => theme.border.color.light};

  h2 {
    font-size: ${({ theme }) => theme.font.size.lg};
    font-weight: ${({ theme }) => theme.font.weight.semiBold};
    color: ${({ theme }) => theme.font.color.primary};
    margin: 0;
  }
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: ${({ theme }) => theme.font.color.tertiary};
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  transition: ${({ theme }) => theme.animation.transition.standard};

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.focusShadow(theme.accent.tertiary)};
  }

  &:hover {
    color: ${({ theme }) => theme.font.color.primary};
    background: ${({ theme }) => theme.background.tertiary};
  }
`;

export const ModalBody = styled.div`
  padding: ${({ theme }) => theme.spacing(5)};
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(4, 5)};
  border-top: 1px solid ${({ theme }) => theme.border.color.light};
`;
